import {GetterTree} from 'vuex'

export const getters: GetterTree<any, any> = {

    clusterStatsMemory: (state: any) => {
        return [
            {name: 'Total memory', value: Math.round(state.clusterStats.nodes.os.mem.total_in_bytes / (1024 * 1024))},
            {name: 'Free memory', value: Math.round(state.clusterStats.nodes.os.mem.free_in_bytes / (1024 * 1024))},
            {name: 'Used memory', value: Math.round(state.clusterStats.nodes.os.mem.used_in_bytes / (1024 * 1024))},
            {name: 'Used FS', value: Math.round(state.clusterStats.nodes.fs.available_in_bytes / (1024 * 1024))},
            {name: 'Total FS', value: Math.round(state.clusterStats.nodes.fs.total_in_bytes / (1024 * 1024))},
        ];
    },

    clusterStatsHardware: (state: any) => {

        return [
            {name: '# of nodes', value: state.clusterStats.nodes.count.total},
            {name: '# of shards', value: state.clusterStats.indices.shards.total},
            {name: 'Available CPUs', value: state.clusterStats.nodes.os.available_processors},
            {name: 'Version', value: state.clusterStats.nodes.versions[0]},
            {name: 'CPU load', value: Math.round(state.clusterStats.nodes.process.cpu.percent) +'%'},
        ];
    },

    clusterState: (state:any) => {
        return state.clusterStats.status;
    },
}
